import { CTAWrapper } from "../CTA";

export const PillWithText = ({ imageComponent, headerText, subtitle, content, formattedSectionStyles, ctas }) => {
	return (
		<article className={`flex flex-col md:gap-12 md:flex-row max-w-[1100px] md:justify-between`}>
			<div className="relative hidden md:block md:flex-[6] md:basis-6/12 mx-auto max-w-[500px]">
				{imageComponent}
				<div className="[&_h4]:text-is2-yellow-500 [&_h4]:text-[24px] [&_h4]:font-bold [&_p]:text-center [&_h4]:text-center">
					{content}
				</div>
			</div>
			<div className="md:flex-[6] md:basis-6/12 flex flex-col justify-center text-center w-full md:max-w-[400px] ">
				{subtitle && <span className={` ${formattedSectionStyles.textColor}`}>{subtitle}</span>}
				{headerText && <h2 className={`${formattedSectionStyles.textColor} mt-2 mb-9 `}>{headerText}</h2>}
				<div className="relative block md:hidden ">
					{imageComponent}
					<div className="[&_h4]:text-is2-yellow-500 [&_h4]:text-[24px] [&_h4]:font-bold ">{content}</div>
				</div>
				{ctas && ctas.length > 0 && (
				<div className="mt-4">
					{ctas.map((cta, index) => (
						<CTAWrapper key={`${cta.title}-${index}`} cta={cta} />
					))}
				</div>
			)}
			</div>
		</article>
	);
};
